import { jarvisPrimeOnboardingConstants } from "./jarvisPrimeOnboardingConstants";

const jarvisPrimeOnboardingActions = {};

jarvisPrimeOnboardingActions.getPrimePlanList = () => {
  return {
    type: jarvisPrimeOnboardingConstants.PRIME_PLAN_SAGA,
  };
};

jarvisPrimeOnboardingActions.updatePrimeOnboardingData = (payload = {}) => ({
  type: jarvisPrimeOnboardingConstants.PRIME_UPDATE_ONBOARDING_DATA,
  payload,
});

jarvisPrimeOnboardingActions.getBrokerList = ({
  isFetchHoldingEnabled,
  isIntegrated,
  searchTerm,
  productCode,
}) => {
  return {
    type: jarvisPrimeOnboardingConstants.BROKER_LIST_SAGA,
    payload: { isFetchHoldingEnabled, isIntegrated, searchTerm, productCode },
  };
};
jarvisPrimeOnboardingActions.getOnboardingData = () => ({
  type: jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_SAGA,
});

jarvisPrimeOnboardingActions.getPortfolioData = () => {
  return {
    type: jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_SAGA,
  };
};

jarvisPrimeOnboardingActions.getPricingData = () => ({
  type: jarvisPrimeOnboardingConstants.PRICING_DATA_SAGA,
});

jarvisPrimeOnboardingActions.getPricingDataResponse = (payload = {}) => ({
  type: jarvisPrimeOnboardingConstants.PRICING_DATA_RESPONSE,
  payload,
});

export { jarvisPrimeOnboardingActions };
